import React, { useEffect } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import "primeicons/primeicons.css";

import {
  createBrowserRouter,
  useNavigate,
  RouterProvider,
} from "react-router-dom";

import App from "./App";
import EditReportPage from "./Components/ReportPage/ReportEdit/EditReportPage";
import Dashboard from "./Components/Overview/Overview";
import Settings from "./Components/Settings/Settings";
import SettingsIndex from "./Components/Settings/SettingsIndex";
import DataCleanup from "./Components/Settings/DataCleanup";
import ManageTeams from "./Components/Settings/TeamSettings/ManageTeams";
import ReportSummaryPage from "./Components/ReportPage/ReportSummaryPage";
import ReportsIndex from "./Components/ReportPage/ReportsIndex";
import StoriesIndex from "./Components/Stories/StoriesIndex";
import CheatSheetsIndex from "./Components/CheatSheets/CheatSheetsIndex";
import DataImport from "./Components/Settings/DataImport";
import HotTopicsAdmin from "./Components/Settings/HotTopicsAdmin/HotTopicsAdmin";
import DataExportPage from "./Components/Settings/DataExportPage";
import NotificationSettings from "./Components/Settings/Notifications/NotificationsSettings";

if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js")
      .then((registration) => {
        console.log("ServiceWorker registered with scope:", registration.scope);

        // Check for updates to the service worker
        registration.onupdatefound = () => {
          const installingWorker = registration.installing;
          if (installingWorker) {
            installingWorker.onstatechange = () => {
              if (installingWorker.state === "installed") {
                if (navigator.serviceWorker.controller) {
                  console.log("New content is available; please refresh.");
                  // TODO: You can show a notification or a banner prompting users to refresh the app
                } else {
                  console.log("Content is cached for offline use.");
                }
              }
            };
          }
        };
      })
      .catch((error) => {
        console.error("ServiceWorker registration failed:", error);
      });
  });
}

function NotFound() {
  let navigate = useNavigate();
  useEffect(() => {
    navigate("/dashboard");
  }, [navigate]);

  return null;
}

const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    children: [
      {
        path: "/",
        element: <Dashboard />,
      },
      {
        path: "/overview",
        element: <Dashboard />,
      },
      {
        path: "/reports",
        element: <ReportsIndex />,
        children: [
          {
            path: "/reports/",
            element: <ReportSummaryPage />,
          },
          {
            path: "/reports/report-edit/:reportId",
            element: <EditReportPage />,
          },
        ],
      },
      {
        path: "/stories",
        element: <StoriesIndex />,
      },
      {
        path: "help",
        element: <SettingsIndex />,
        children: [
          {
            path: "/help/",
            element: <Settings />,
          },
          {
            path: "/help/datacleanup",
            element: <DataCleanup />,
          },
          {
            path: "/help/dataimport",
            element: <DataImport />,
          },
          {
            path: "/help/manage-teams",
            element: <ManageTeams />,
          },
          {
            path: "/help/hot-topics-admin",
            element: <HotTopicsAdmin />,
          },
          {
            path: "/help/data-export",
            element: <DataExportPage />,
          },
          {
            path: "/help/cheatsheets",
            element: <CheatSheetsIndex />,
          },
          {
            path: "/help/notifications",
            element: <NotificationSettings />,
          },
        ],
      },
      {
        path: "*",
        element: <NotFound />,
      },
    ],
  },
]);

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);

reportWebVitals();
